/**
 * v4 UUID generator. Uses `crypto.randomUUID` when available (modern browsers
 * + Node ≥ 19), falls back to `Math.random` for older Safari and JSDOM.
 *
 * The fallback is NOT cryptographically secure — only the modern path is —
 * but it's sufficient for non-secret identifiers (pageview_id, window_id,
 * etc.) where we just need uniqueness within a session.
 */
export function generateUUID(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    const v = c === 'x' ? r : (r % 4) + 8;
    return v.toString(16);
  });
}
